import React from 'react';
import { Table, Badge, Button } from '@/components/ui';
import { formatCurrency } from '@/utils/format';

interface ContractZonesTableProps {
  zones: any[];
  isLoading?: boolean;
  onDelete?: (assignmentId: string) => void;
}

const difficultyColors: Record<string, string> = {
  easy: 'bg-emerald-50 text-emerald-600 border-emerald-100',
  medium: 'bg-amber-50 text-amber-600 border-amber-100',
  hard: 'bg-red-50 text-red-600 border-red-100',
};

const frequencyLabels: Record<string, string> = {
  daily: 'Hàng ngày',
  weekly: 'Hàng tuần',
  monthly: 'Hàng tháng',
  quarterly: 'Hàng quý',
};

export function ContractZonesTable({ zones, isLoading, onDelete }: ContractZonesTableProps) {
  const columns = [
    {
      key: 'zone',
      title: 'Khu vực',
      render: (zone: any) => (
        <div className="flex flex-col">
          <span className="text-[10px] font-bold text-slate-400  tracking-wider">{zone?.zone_code}</span>
          <span className="font-bold text-slate-900">{zone?.zone_name}</span>
        </div>
      )
    },
    {
      key: 'area_m2',
      title: 'Diện tích',
      render: (area: number, item: any) => (
        <div className="flex items-center gap-1">
          <span className="text-sm font-bold text-slate-900">
            {(area || item.zone?.area_m2)?.toLocaleString() || '-'}
          </span>
          <span className="text-[10px] text-slate-400">m²</span>
        </div>
      )
    },
    {
      key: 'visit_frequency',
      title: 'Tần suất',
      render: (freq: string) => (
        <Badge variant="custom" className="text-[10px] font-bold  bg-slate-50 border-slate-200 text-slate-600">
          <i className="ri-calendar-check-line mr-1" />
          {frequencyLabels[freq] || freq || 'Chưa đặt'}
        </Badge>
      )
    },
    {
      key: 'difficulty_level',
      title: 'Mức độ',
      render: (level: string) => (
        <Badge
          variant="outline"
          className={`text-[10px] font-bold  ${difficultyColors[level] || 'bg-slate-50 text-slate-600 border-slate-200'}`}
        >
          {level === 'easy' ? 'Dễ' : level === 'medium' ? 'Trung bình' : level === 'hard' ? 'Khó' : level}
        </Badge>
      )
    },
    {
      key: 'actions',
      title: '',
      render: (_: any, item: any) => (
        <div className="flex justify-end gap-1">
          <Button variant="ghost" size="sm" icon="ri-settings-4-line" title="Cấu hình tần suất" />
          <Button
            variant="ghost"
            size="sm"
            icon="ri-delete-bin-line"
            className="text-red-500 hover:bg-red-50"
            title="Gỡ khỏi hợp đồng"
            onClick={() => onDelete?.(item.id)}
          />
        </div>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      data={zones}
      isLoading={isLoading}
      emptyMessage="Chưa có khu vực nào được gán vào hợp đồng này."
    />
  );
}
